<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} giá dịch vụ</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} giá dịch vụ</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} giá dịch vụ</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="2">
              <el-form-item class="mb-0 mb-3" label="Ảnh" prop="anh_hien_thi">
                <el-upload action multiple :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="10">
              <el-form-item label="Chính sách" prop="chinh_sach">
                <el-input :disabled="mData.viewMode == 'detail'" type="textarea" :rows="2"
                  v-model="mData.dataForm.chinh_sach">
                </el-input>
                <!-- <CknoimgComponent
                    v-model="mData.dataForm.chinh_sach"
                    :prop-data-editor-disabled="mData.viewMode == 'detail'"
                    @blur="handleBlur('chinh_sach')"
                  ></CknoimgComponent> -->
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Màn hình" prop="man_hinh">
                <el-select v-model="mData.dataForm.man_hinh" @change="changePage(mData.dataForm.man_hinh)"
                  :placeholder="aLang.c_select" :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listTrang" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                <el-select v-model="mData.dataForm.ngon_ngu" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Hiển thị" prop="hien_thi">
                <el-select v-model="mData.dataForm.hien_thi" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12" class="mt-4">
              <b-card>
                <div slot="header">
                  Giá tiền theo vị trí
                  <div class="card-header-actions"></div>
                </div>
                <b-row>
                  <b-col md="3" v-for="item in mData.dataForm.gia_tien" :key="item.id">
                    <el-form-item :label="(item.vi_tri ? item.vi_tri : '')" prop="">
                      <el-input v-currency="options" v-model="item.gia_tien" :disabled="mData.viewMode == 'detail'"
                        clearable></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from '@/service/DataService';
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import BangGiaQuangCaoModel from '@/views/admin/BangGiaQuangCao/BangGiaQuangCaoModel';
import DichVuQuangCaoApi from '@/moduleApi/DichVuQuangCaoApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import MapboxComponent from "../../../component/MapboxComponent";
import { parse } from "vue-currency-input";

export default {
  components: {
    CknoimgComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aRole: MethodService.checkRole,
      mData: {
        viewMode: "create",
        moduleName: "BangGiaQuangCao",
        dataDefault: {
          showMap: false,
          listProvince: [],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listTrang: DataService.danhSachTrang,
          listSoLuongQuangCao: DataService.soLuongQuangCao,
          listGiaTien: []
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        dataForm: MethodService.copyObject(BangGiaQuangCaoModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          BangGiaQuangCaoModel.dataFormOther.fileUploadOption
        ),
        validForm: BangGiaQuangCaoModel.validForm,
      },
    };
  },
  computed: {
    options() {
      return {
        locale: 'en',
        currency: null,
        valueAsInteger: false,
        distractionFree: true,
        precision: 0,
        autoDecimalMode: true,
        valueRange: { min: 0 },
        allowNegative: false
      };
    },
    numberValue() {
      return parse(this.mData.dataForm.gia_tien.gia_tien, this.options);
    }
  },
  async mounted() {

  },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }

  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (this.mData.dataDefault.tourTimeErrorMessage) {
          window.toastr.warning(this.mData.dataDefault.tourTimeErrorMessage);
          this.$refs["startDate"].focus();
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
          MethodService.stopLadda();
          return false;
        }
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            await DichVuQuangCaoApi.create(data);
          }
          if (type === "update") {
            let giaTien = [];
            for (let i = 0; i < data.gia_tien.length; i++) {
              giaTien.push({
                vi_tri: data.gia_tien[i].vi_tri,
                gia_tien: data.gia_tien[i].gia_tien.replaceAll(/\./g, ",")
              })
            }
            data.gia_tien = giaTien;
            await DichVuQuangCaoApi.update(data);
          }
          this.fn_go();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        BangGiaQuangCaoModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      const bangGiaQuangCaoRes = await DichVuQuangCaoApi.findById(id);
      if (bangGiaQuangCaoRes.result) {
        // let resData = await this.fn_changeData(bangGiaQuangCaoRes.result);
        let dataChung = {
          id: bangGiaQuangCaoRes.result.anh_hien_thi,
          name: bangGiaQuangCaoRes.result.anh_hien_thi,
          url: ExtensionService.urlImg + bangGiaQuangCaoRes.result.anh_hien_thi
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(dataChung);
        this.mData.dataForm = bangGiaQuangCaoRes.result;
        if (!bangGiaQuangCaoRes.result.gia_tien) {
          this.changePage(this.mData.dataForm.man_hinh);
        } else {
          this.mData.dataForm.gia_tien = [];
          this.formatCurrency();
        }
      }
      this.forceUpdateUI();
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    changePage(value) {
      let soLuongQuangCao = [];
      for (let i = 0; i < this.mData.dataDefault.listSoLuongQuangCao.length; i++) {
        if (value == this.mData.dataDefault.listSoLuongQuangCao[i].value) {
          for (let j = 1; j <= this.mData.dataDefault.listSoLuongQuangCao[i].count; j++) {
            soLuongQuangCao.push({
              vi_tri: "Vị trí " + j,
              gia_tien: null
            })
            this.mData.dataForm.gia_tien = soLuongQuangCao;
          }
        }
      }
    },

    async formatCurrency() {
      const bangGiaQuangCaoRes = await DichVuQuangCaoApi.findById(this.$router.currentRoute.params.id);
      if (bangGiaQuangCaoRes.result && bangGiaQuangCaoRes.result.gia_tien) {
        for (let i = 0; i < bangGiaQuangCaoRes.result.gia_tien.length; i++) {
          this.mData.dataForm.gia_tien.push({
            vi_tri: bangGiaQuangCaoRes.result.gia_tien[i].vi_tri,
            gia_tien: new Intl.NumberFormat('vi-VN').format(bangGiaQuangCaoRes.result.gia_tien[i].gia_tien)
          })
        }
      }
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("anh_hien_thi");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "BangGiaQuangCao")
        .then(res => {
          this.mData.dataForm.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("anh_hien_thi");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("anh_hien_thi");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
<style>
@media (min-width: 1220px) {
  .col-custom {
    max-width: 20%;
  }
}
</style>
